import { render, staticRenderFns } from "./UpgradeButton.vue?vue&type=template&id=2470cb08&scoped=true&"
import script from "./UpgradeButton.vue?vue&type=script&lang=js&"
export * from "./UpgradeButton.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeButton.vue?vue&type=style&index=0&id=2470cb08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470cb08",
  null
  
)

/* custom blocks */
import block0 from "./UpgradeButton.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports